import { CustomerAccounts } from '@/features/accounts/CustomerAccounts.tsx';
import { SearchPaginationContextProvider } from '@arsnovasystems/ars-front-lib';

/**
 * Wraps the customer accounts view with the search and pagination context
 * required by the accounts feature.
 *
 * @returns The customer accounts page wrapped in a
 *  `SearchPaginationContextProvider`.
 */
export const CustomerAccountsContainer = () => {
  return (
    <SearchPaginationContextProvider>
      <CustomerAccounts />
    </SearchPaginationContextProvider>
  );
};
